import { createHttpService } from 'src/apis/ApiService';
import { GuardianChild } from 'src/views/modules/guardian/guardian.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

const useGuardianChildrenService = () => {
  const httpAPI = createHttpService();
  const baseGuardianPath = '/guardian/children';
  const withMockData = isAppWithMock();

  const getChildren = (): Promise<GuardianChild[]> => {
    if (withMockData) {
      return Promise.resolve([
        {
          id: 'child-1',
          name: 'Arjun Kumar',
          grade: 'Grade 5',
          section: 'A',
        },
        {
          id: 'child-2',
          name: 'Priya Sharma',
          grade: 'Grade 3',
          section: 'B',
        },
      ]);
    }

    return httpAPI
      .get<GuardianChild[]>(baseGuardianPath)
      .then((response) => (Array.isArray(response) ? response : []))
      .catch((error) => {
        console.error('Error fetching guardian children:', error);
        return [];
      });
  };

  return {
    getChildren,
  };
};

export default useGuardianChildrenService;
